module.exports = __webpack_public_path__ + "img/orders-header.6c2e9e05.png";